import React, { useRef } from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { Entypo, Feather } from '@expo/vector-icons';
import { useHover } from 'react-native-web-hooks';
import { LocStr } from '../utils/Utils';
import { Block_user, Unblock_user } from '../utils/DictionaryManagementUtils';

//= ========================================================================

const MyTableLine = ({
  width,
  rowIndex,
  arrValues,
  onCellPressed,
  onActionPressed,
  isTheLoggedinUser = false,
  canDeleteOrBlock = true,
  language,
}) => {
  const theRefEdit = useRef(null);
  const theRefBlock = useRef(null);
  const theRefDelete = useRef(null);
  const theRefLogin = useRef(null);
  // const theRefDownload = useRef(null);
  // const theRefUpload = useRef(null);

  const isHoveredEdit = useHover(theRefEdit);
  const isHoveredBlock = useHover(theRefBlock);
  const isHoveredDelete = useHover(theRefDelete);
  const isHoveredLogin = useHover(theRefLogin);
  // const isHoveredDownload = useHover(theRefDownload);
  // const isHoveredUpload = useHover(theRefUpload);

  //----------------------------------------------------------

  const renderLine = () => arrValues.map((item, index) => {
    if (index === arrValues.length - 1) {
      // STATUS column
      const font = item === 'Done'
        ? 'Rubik-Medium'
        : item === 'Blocked'
          ? 'Rubik-Medium'
          : 'Rubik-Regular';
      const color = item === 'Done' ? '#0a0' : item === 'Blocked' ? '#f00' : '#3f3f3f';

      return (
        <View
          style={{
            width: 80,
            height: 30,
            justifyContent: 'center',
            backgroundColor: '#fff',
          }}
          key="actions"
        >
          <View
            style={{
              marginLeft: 0,
              height: 30,
              width: 1,
              backgroundColor: '#001a2f',
              position: 'absolute',
            }}
          />
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            style={{
              textAlign: 'center',
              fontFamily: font,
              fontSize: 14,
              color,
            }}
          >
            {item}
          </Text>
        </View>
      );
    }

    return (
      <TouchableOpacity
        style={{
          flex: 1,
          height: 30,
          justifyContent: 'center',
          backgroundColor: '#fff',
        }}
        key={index}
        onPress={() => {
          onCellPressed(rowIndex, index);
        }}
      >
        {index === 0 ? null : (
          <View
            style={{
              marginLeft: 0,
              height: 31,
              width: 1,
              backgroundColor: '#a9a9a9',
              position: 'absolute',
            }}
          />
        )}

        <Text
          numberOfLines={1}
          ellipsizeMode="tail"
          style={{
            // flex:1,
            textAlign: 'center',
            // alignSelf:'center',
            fontFamily: isTheLoggedinUser ? 'Rubik-Medium' : 'Rubik-Regular',
            fontSize: 14,
            color: isTheLoggedinUser ? '#006DC7' : '#3f3f3f',
            // backgroundColor:'#0f0',
          }}
        >
          {item}
        </Text>
      </TouchableOpacity>
    );
  });

  //-------------------------------------------------------------------------------

  const tooltipFrameStyle = {
    width: 86,
    height: 22,
    marginLeft: -43 + 8,
    marginTop: -22,
    position: 'absolute',
    borderRadius: 3,
    borderColor: '#d9d9d9',
    borderWidth: 1,
    backgroundColor: '#edf2f7',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.12,
    shadowRadius: 10,
  };

  const tooltipTextStyle = {
    fontFamily: 'Quicksand-Bold',
    fontSize: 11,
    color: '#001a2f',
    textAlign: 'center',
  };

  //-------------------------------------------------------------------------------

  const isBlocked = arrValues[arrValues.length - 1] === 'Blocked';
  const canBlock = isBlocked || canDeleteOrBlock;
  return (
    <View
      style={{
        width,
        height: 32,
        marginTop: 0,
        marginLeft: 0,
        backgroundColor: '#001a2f',
      }}
    >
      <View
        style={{
          width: width - 2,
          height: 1,
          marginLeft: 1,
          marginTop: 0,
          backgroundColor: rowIndex === 0 ? '#fff' : '#a9a9a9',
          position: 'absolute',
        }}
      />

      <View
        style={{
          width: width - 2,
          height: 31,
          marginLeft: 1,
          marginTop: 1,
          position: 'absolute',
          backgroundColor: '#a9a9a9',
          flexDirection: 'row',
        }}
      >
        {renderLine()}

        <View
          style={{
            width: 190 - 60,
            height: 30,
            flexDirection: 'row',
            backgroundColor: '#fff',
          }}
          key="actions"
        >
          <View
            style={{
              marginLeft: 0,
              height: 30,
              width: 1,
              backgroundColor: '#001a2f',
              position: 'absolute',
            }}
          />

          <TouchableOpacity
            style={{ width: 30, height: 30 }}
            onPress={() => {
              onActionPressed('edit', rowIndex);
            }}
            ref={theRefEdit}
          >
            <Feather
              name="edit-2"
              style={{
                fontSize: 16,
                position: 'absolute',
                color: '#3f3f3f',
                marginLeft: 8,
                marginTop: 8,
              }}
            />

            {isHoveredEdit ? (
              <View style={tooltipFrameStyle} pointerEvents="none">
                <Text style={tooltipTextStyle}>
                  {LocStr('Edit user', language)}
                </Text>
              </View>
            ) : null}
          </TouchableOpacity>

          <TouchableOpacity
            style={{ width: 30, height: 30 }}
            onPress={() => {
              onActionPressed('block', rowIndex);
            }}
            disabled={!canBlock}
            ref={theRefBlock}
          >
            <Feather
              name={isBlocked ? 'unlock' : 'lock'}
              style={{
                fontSize: 16,
                position: 'absolute',
                color: canBlock ? '#f00' : '#c9c9c9',
                marginLeft: 8,
                marginTop: 8,
              }}
            />

            {canBlock && isHoveredBlock ? (
              <View style={tooltipFrameStyle} pointerEvents="none">
                <Text style={tooltipTextStyle}>
                  {LocStr(isBlocked ? Unblock_user : Block_user, language)}
                </Text>
              </View>
            ) : null}
          </TouchableOpacity>

          <TouchableOpacity
            style={{ width: 30, height: 30 }}
            onPress={() => {
              onActionPressed('delete', rowIndex);
            }}
            disabled={!canDeleteOrBlock}
            ref={theRefDelete}
          >
            <Feather
              name="trash-2"
              style={{
                fontSize: 16,
                position: 'absolute',
                color: canDeleteOrBlock ? '#f00' : '#c9c9c9',
                marginLeft: 8,
                marginTop: 8,
              }}
            />

            {canDeleteOrBlock && isHoveredDelete ? (
              <View style={tooltipFrameStyle} pointerEvents="none">
                <Text style={tooltipTextStyle}>
                  {LocStr('Delete user', language)}
                </Text>
              </View>
            ) : null}
          </TouchableOpacity>

          <TouchableOpacity
            style={{ width: 30, height: 30, marginLeft: 10 }}
            onPress={() => {
              onActionPressed('login', rowIndex);
            }}
            ref={theRefLogin}
          >
            <Entypo
              name="login"
              style={{
                fontSize: 16,
                position: 'absolute',
                color: '#3f3f3f',
                marginLeft: 8,
                marginTop: 8,
              }}
            />

            {isHoveredLogin ? (
              <View
                style={[tooltipFrameStyle, { width: 65 }]}
                pointerEvents="none"
              >
                <Text style={tooltipTextStyle}>
                  {LocStr('Dashboard', language)}
                </Text>
              </View>
            ) : null}
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default MyTableLine;
